
import useMap from "../../../utils/useMap";
import useWeakMap from "../../../utils/useWeakMap";
import { runExtractValue } from "../../executor";
import { extractContentByTag } from "../../util";
import { checkNodeIsVisible } from "../structure/if";
import { canBindingNode } from "../useBinding";
import useWatcher from "../useWatcher";

const sanitizeHTML = (html) => {
    // Create a temporary DOM element to hold the HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    // Find and remove all <script> elements
    const scripts = tempDiv.getElementsByTagName('script');
    while (scripts.length > 0) {
        scripts[0].parentNode.removeChild(scripts[0]);
    }
    const styles = tempDiv.getElementsByTagName('style');
    while (styles.length > 0) {
        styles[0].parentNode.removeChild(styles[0]);
    }

    // Return the sanitized HTML
    return tempDiv.innerHTML;
}


const useHTMLInterpolation = (() => {

    const caching = useWeakMap();
    const valueCaching = useMap();

    const render = (node, props, attrValue) => {
        if (!canBindingNode(node)) return;
        if (!caching.has(node)) return;

        const html = runExtractValue(props, attrValue);
        node.innerHTML = sanitizeHTML(html);
    }

    /**
     * @param {{ attrName: string, attrValue: string }} attr
     * @param {object} props
     * @param {Node} node
     */
    return (attr, props, node) => {
        if (!caching.has(node)) {
            caching.set(node, []);
        }
        const { attrName, attrValue } = attr;

        const { onPropChanges, onCreated, onDestroy } = useWatcher(props, node, [attrValue]);


        onPropChanges(() => {
            render(node, props, attrValue)
        });

        onDestroy(() => {
            caching.delete(node);
        })

        return new Promise((next) => {
            if (false === checkNodeIsVisible(node)) {
                onCreated(() => render(node, props, attrValue))
                next();
                return;
            }
            next();
        })
    }
})();

export default useHTMLInterpolation;
